import { jsx as _jsx } from "react/jsx-runtime";
import { tableCellClasses as muiTableCellClasses, tableClasses as muiTableClasses, } from '@mui/material';
import { forwardRef } from 'react';
import { TableCellStyled } from './TableCell.styled';
/**
 * **Global Parts** `TableCell` component.
 */
const TableCell = forwardRef((props, ref) => {
    return _jsx(TableCellStyled, { ref: ref, ...props });
});
export { TableCell };
export const tableClasses = muiTableClasses;
export const tableCellClasses = muiTableCellClasses;
